import { GameContext } from '../../../contexts/GameContext';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { ZdarGameStepConfiguration } from '../../../configuration/games/zdar-escape-game/zdarEscapeGameContentConfiguration';
import React, { useContext, useEffect, useRef } from 'react';
import ZdarKidsHint from './ZdarKidsHint';

export default function ZdarKidsHints() {
    const { shownHints, stepContent, currentStep } = useContext(GameContext);
    const { availableGame } = useContext(ProfileContext);
    const { hints } = stepContent as ZdarGameStepConfiguration;
    const myRef = useRef(null);

    const executeScroll = () => {
        if (myRef && myRef.current) {
            // @ts-expect-error
            myRef.current.scrollIntoView();
        }
    };

    const stat = '_' + currentStep;
    // @ts-expect-error
    const realShownHints = availableGame !== undefined ? availableGame?.stats[stat]?.hintsTaken : shownHints;

    useEffect(() => {
        executeScroll();
    }, [realShownHints, shownHints]);

    if (!hints || realShownHints === 0) {
        return <React.Fragment />;
    }

    const displayedHints = hints.slice(0, realShownHints + 1);

    return (
        <div className="zdar-kids-hints-wrapper" ref={myRef}>
            <div className="zdar-cipher-text-wrapper">
                <div className="zdar-kids-cipher--label">Řešení</div>
            </div>
            {displayedHints.map((h, i) => {
                return <ZdarKidsHint hint={h} key={i} />;
            })}
        </div>
    );
}
